import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import MediaQuery from "react-responsive";
import { Helmet } from "react-helmet";

import searchIconGrey from "../../images/location-icon.svg";
import searchLoader from "../../images/loading-spinner.svg";
import { queryString, generateQueryStringFromReduxState } from "../../utils";
import Modal from "../Modals";
import { AsynLoader } from "../Loader/AsynLoader";
import { queryStringLocation, fetchLocations, loadLocations } from "../../actions";
import Input from "../FormComponents/Input";

class LocationsFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.query.location.category || "",
      destination: props.query.location.name || "",
      locationId: props.query.location.id || "",
      selectedLocation: props.query.location.name || "",
      showModal: false,
      redirect: "",
      showResult: false,
      show: false
    };
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
    const { name, id } = this.props.query.location;
    if (name && id) {
      this.setState({ destination: name || "", selectedLocation: name || "", locationId: id });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) {
      const { name, id } = this.props.query.location;
      this.setState({ destination: name || "", selectedLocation: name || "", locationId: id });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }

  handleSelect = (id, name, category) => {
    let q = generateQueryStringFromReduxState(this.props.query);
    if (category === "State") {
      if (q.locationId) delete q.locationId;
      q.stateId = id;
    } else {
      if (q.stateId) delete q.stateId;
      q.locationId = id;
    }

    q.destination = name;

    this.setState({
      category: category,
      destination: name,
      selectedLocation: name,
      locationId: id,
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringLocation({ id, name, category });
    this.props.loadLocations([]);
  };
  handleReset = () => {
    let q = generateQueryStringFromReduxState(this.props.query);

    delete q.stateId;
    delete q.locationId;
    delete q.destination;

    this.setState({
      category: "",
      destination: "Anywhere",
      locationId: "",
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringLocation({});
  };

  handleSearch = e => {
    if (e.target.value.length > 2) {
      this.setState({ destination: e.target.value, showResult: true, showModal: true });
      this.props.searchLocation(e.target.value);
    } else {
      this.setState({ destination: e.target.value, showResult: false, showModal: false });
    }
  };

  detectClickOutSide = e => {
    if (window.innerWidth > 700)
      if (!this.locationFilter.contains(e.target)) {
        this.setState({ showModal: false, show: false });
      }
  };

  render() {
    const { categoryName } = this.props.query;
    return (
      <div className="filter__categories" ref={node => (this.locationFilter = node)}>
        {this.state.destination &&
          this.state.destination !== "" &&
          this.state.locationId && (
            <Helmet>
              <title>
                {categoryName && categoryName !== ""
                  ? `${categoryName} in ${this.state.selectedLocation} - Trodly`
                  : `${this.state.selectedLocation} Things To Do in & Activities - Trodly`}
              </title>
              <meta
                name="description"
                content={
                  categoryName && categoryName !== ""
                    ? `Book amazing travel activities and discover the best packages in ${categoryName} in ${
                        this.state.selectedLocation
                      }. Find best price on tours and unique experiences with Trodly.`
                    : `Book amazing travel activities and discover the best things to do in ${
                        this.state.selectedLocation
                      }. Find best price on tours and unique experiences with Trodly.`
                }
              />
            </Helmet>
          )}
        {this.state.redirect !== "" && <Redirect to={this.state.redirect} />}
        <MediaQuery maxWidth={700}>
          {matches => {
            if (matches) {
              return (
                <div
                  className="filter__categories__containers"
                  onClick={() => this.setState({ showModal: true })}
                >
                  <span className="filter__categories__icon__name_container">
                    <span className="navbar__icon destination" />
                    <span className="filter__categories__selected_category">
                      {this.state.destination && this.state.destination !== ""
                        ? this.state.destination
                        : "Anywhere"}
                    </span>
                  </span>
                </div>
              );
            } else {
              const { searchLoading } = this.props;
              return (
                <div style={{ position: "relative" }}>
                  <Input
                    placeholder={`Anywhere`}
                    leftIcon={searchLoading ? searchLoader : searchIconGrey}
                    value={this.state.destination}
                    onChange={this.handleSearch}
                    onFocus={() => this.setState({ show: true })}
                  />
                  {this.state.show &&
                    this.state.destination.length === 0 && (
                      <div className="desktop__location_suggestions">
                        <div className="suggested__locaitons">
                          <a href="/activities-in-manali/1757">
                            <div className="trodly__tertiary__button">Manali</div>
                          </a>
                          <a href="/activities-in-mumbai/2632">
                            <div className="trodly__tertiary__button">Mumbai</div>
                          </a>
                          <a href="/activities-in-bangalore/14">
                            <div className="trodly__tertiary__button">Bangalore</div>
                          </a>
                          <a href="/activities-in-goa/4500">
                            <div className="trodly__tertiary__button">Goa</div>
                          </a>
                          <a href="/activities-in-mysore/36">
                            <div className="trodly__tertiary__button">Mysore</div>
                          </a>
                          <a href="/activities-in-jaipur/1937">
                            <div className="trodly__tertiary__button">Jaipur</div>
                          </a>
                          <a href="/activities-in-kasol/6592">
                            <div className="trodly__tertiary__button">Kasol</div>
                          </a>
                          <a href="/activities-in-leh/3300">
                            <div className="trodly__tertiary__button">Ladakh</div>
                          </a>
                        </div>
                      </div>
                    )}
                  {this.state.locationId &&
                    this.state.destination !== "" && (
                      <span
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: 8,
                          transform: "translateY(-50%)"
                        }}
                        className="banner__field__close_icon"
                        onClick={this.handleReset}
                      />
                    )}
                </div>
              );
            }
          }}
        </MediaQuery>
        {this.state.showModal && (
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <Modal close={() => this.setState({ showModal: false })} reset={this.handleReset}>
                    <AsynLocationSearch
                      selected={this.state.categoryLink}
                      handleSelect={this.handleSelect}
                    />
                  </Modal>
                );
              } else {
                const { locations } = this.props;
                return (
                  <Fragment>
                    {this.state.showResult && (
                      <ul className="dropdown__list">
                        {locations &&
                          locations.map(location => (
                            <li
                              className="item"
                              key={location.id}
                              onClick={() =>
                                this.handleSelect(location.id, location.value, location.category)
                              }
                            >
                              {location.label}
                            </li>
                          ))}
                      </ul>
                    )}
                  </Fragment>
                );
              }
            }}
          </MediaQuery>
        )}
      </div>
    );
  }
}

const AsynLocationSearch = Loadable({
  loader: () => import("../Modals/LocationFilter"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});
const mapStateToProps = state => {
  return {
    query: state.queryString,
    searchLoading: state.searchLoading,
    locations: state.locationSearchResults
  };
};

const mapDispatchToProps = dispatch => {
  return {
    queryStringLocation: location => dispatch(queryStringLocation(location)),
    searchLocation: str => dispatch(fetchLocations(str)),
    loadLocations: location => dispatch(loadLocations(location))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationsFilters);
